/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TaskChainDTO } from '../models/TaskChainDTO'
import type { TaskDTO } from '../models/TaskDTO'
import type { TaskWithArgsDTO } from '../models/TaskWithArgsDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AnalyticsAdminTasksService {
    /**
     * Analytics Dag
     * @returns TaskChainDTO Successful Response
     * @throws ApiError
     */
    public static analyticsDagAnalyticsAdminTasksDagGet({
        deliveredDatabase,
        analyticsSeedDatabase,
        selector = '+models/rwd',
        createVersionedDatabase = false
    }: {
        /**
         * Versioned delivered database e.g. DELIVERED_214 or DEIDDEV_10397 - defaults to most recent DEIDDEV/DELIVERED depending on the environment
         */
        deliveredDatabase?: string
        /**
         * Versioned analytics seed database e.g. ANALYTICS_SEED_05092024 - defaults to most recent ANALYTICS_SEED for the environment
         */
        analyticsSeedDatabase?: string
        selector?: string
        /**
         * Create a new database version. Requires the selector "+models/rwd"
         */
        createVersionedDatabase?: boolean
    }): CancelablePromise<TaskChainDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/analytics/admin/tasks/dag',
            query: {
                delivered_database: deliveredDatabase,
                analytics_seed_database: analyticsSeedDatabase,
                selector: selector,
                create_versioned_database: createVersionedDatabase
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Analytics Dbt Build
     * @returns TaskWithArgsDTO Successful Response
     * @throws ApiError
     */
    public static analyticsDbtBuildAnalyticsAdminTasksDbtBuildGet({
        deliveredDatabase,
        analyticsSeedDatabase,
        selector = '+models/rwd'
    }: {
        /**
         * Versioned delivered database e.g. DELIVERED_214 or DEIDDEV_10397 - defaults to most recent DEIDDEV/DELIVERED depending on the environment
         */
        deliveredDatabase?: string
        /**
         * Versioned analytics seed database e.g. ANALYTICS_SEED_05092024 - defaults to most recent ANALYTICS_SEED for the environment
         */
        analyticsSeedDatabase?: string
        selector?: string
    }): CancelablePromise<TaskWithArgsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/analytics/admin/tasks/dbt_build',
            query: {
                delivered_database: deliveredDatabase,
                analytics_seed_database: analyticsSeedDatabase,
                selector: selector
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Analytics Publish Dbt Docs
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static analyticsPublishDbtDocsAnalyticsAdminTasksPublishDbtDocsGet({
        deliveredDatabase = 'DEIDDEV',
        analyticsSeedDatabase = 'ANALYTICS_SEED_DEV'
    }: {
        /**
         * must be either 'DEIDDEV' or 'DELIVERED'
         */
        deliveredDatabase?: string
        /**
         * must be one of 'ANALYTICS_SEED', 'ANALYTICS_SEED_DEV', or 'ANALYTICS_SEED_LOCAL'
         */
        analyticsSeedDatabase?: string
    }): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/analytics/admin/tasks/publish_dbt_docs',
            query: {
                delivered_database: deliveredDatabase,
                analytics_seed_database: analyticsSeedDatabase
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Update Analytics Metadata
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static updateAnalyticsMetadataAnalyticsAdminTasksUpdateAnalyticsMetadataGet(): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/analytics/admin/tasks/update_analytics_metadata'
        })
    }
    /**
     * Version Analytics Seed
     * @returns any Successful Response
     * @throws ApiError
     */
    public static versionAnalyticsSeedAnalyticsAdminTasksVersionAnalyticsSeedGet(): CancelablePromise<TaskChainDTO | TaskWithArgsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/analytics/admin/tasks/version_analytics_seed'
        })
    }
    /**
     * Refresh Product Custom Cohort
     * @returns TaskChainDTO Successful Response
     * @throws ApiError
     */
    public static refreshProductCustomCohortAnalyticsAdminTasksRefreshProductCustomCohortGet(): CancelablePromise<TaskChainDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/analytics/admin/tasks/refresh_product_custom_cohort'
        })
    }
}
